import { gql } from '@apollo/client';

export const DELETE_COMMUNITY_TOPIC = gql`
  mutation DeleteCommunityTopic($communityId: ID!, $topicName: String!) {
    deleteCommunityTopic(communityId: $communityId, topicName: $topicName)
  }
`;
